import api from '@pray/shared/utils/api';

import type { WarmupCampaign, WarmupPlan, WarmupPlanInput } from './types';

/**
 * Re-plans the days still to send. Sent and missed days stay as they are; the server answers with the
 * plan it materialised, which is what the page shows from then on. A plan with an error is a 400.
 */
export async function updateWarmupPlan({
  artistId,
  warmupCampaignId,
  planInput,
  refreshAudience = false,
}: {
  artistId: string;
  warmupCampaignId: string;
  planInput: WarmupPlanInput;
  /** Re-count the eligible leads instead of keeping the audience frozen at the last plan */
  refreshAudience?: boolean;
}): Promise<{ object: WarmupCampaign; plan: WarmupPlan }> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!warmupCampaignId) throw new Error('Warmup campaign ID is required');

  const url = `/web/studio/artists/${artistId}/warmup-campaigns/${warmupCampaignId}/plan`;
  const response = await api.executePutRequest<{ data: { object: WarmupCampaign; plan: WarmupPlan } }>(url, {
    plan_input: planInput,
    refresh_audience: refreshAudience,
  });
  return response.data.data;
}
